<div class="content">
  <app-header></app-header>
  <app-loader></app-loader>
  <div class="page">
    <app-workspace></app-workspace>
  </div>
</div>
<app-footer></app-footer>
